<template>
	<div class="p-6 flex flex-col justify-center space-y-6">
		<h2 class="text-3xl font-bold text-gray-900">
			{{ __("Welcome") }}
			{{ user.name }},
			{{ __("glad you are here!") }}
		</h2>

		<p>Ihr Konto wird geprüft und demnächst freigeschaltet</p>
	</div>
</template>

<script>
export default {
	props: {
		user: {
			type: Object,
			required: true,
		},
	},
};
</script>
